import { createAPIActions } from 'barnyard/utils';
import {
  NEUTRAL,
  SUCCESS,
  DANGER,
  PRIMARY,
  WARNING,
} from 'barnyard/colors';
import _ from 'lodash';

export const NAME = 'history';
export const VETCOVE_DIRECT_SUPPLIER_SLUG = 'vetcove';

// Order Search
export const ORDERS_FETCH = createAPIActions(`${NAME}/ORDERS_FETCH`);
export const ORDERS_FETCH_SUCCESS = `${NAME}/ORDERS_FETCH_SUCCESS`;
export const ORDERS_SEARCH_SUCCESS = `${NAME}/ORDERS_SEARCH_SUCCESS`;
export const ORDER_ITEMS_SEARCH_SUCCESS = `${NAME}/ORDER_ITEMS_SEARCH_SUCCESS`;
export const ORDER_FETCH = createAPIActions(`${NAME}/ORDER_FETCH`);
export const ORDER_UPDATE = createAPIActions(`${NAME}/ORDER_UPDATE`);
export const ORDER_ITEM_UPDATE = createAPIActions(`${NAME}/ORDER_ITEM_UPDATE`);
export const ORDER_ITEMS_REQUEST = `${NAME}/ORDER_ITEMS_REQUEST`;
export const ORDER_ITEMS_SUCCESS = `${NAME}/ORDER_ITEMS_SUCCESS`;
export const ORDER_TRACKERS_FETCH = createAPIActions(`${NAME}/ORDER_TRACKERS_FETCH`);
export const CORP_DASHBOARD_ANALYITICS = createAPIActions(`${NAME}/CORP_DASHBOARD_ANALYITICS`);

export const TRACKER_DELETE = createAPIActions('orders/TRACKER_DELETE');
export const INVOICE_ITEM_GL_UPDATE = createAPIActions(`${NAME}/INVOICE_ITEM_GL_UPDATE`);

export const ORDER_TRACKERS_FETCH_EVENT_TYPE = 'order-trackers';
export const CORPORATE_ANALYTICS_EVENT_TYPE = 'corporate-analytics';
export const CORPORATE_ANALYTICS_EVENTS = {
  DASHBOARD: 'dashboard'
};


export const ORDERS_RESET = 'ORDERS_RESET';
export const ORDER_ITEMS_RESET = 'ORDER_ITEMS_RESET';
export const ORDER_RETURN = createAPIActions(`${NAME}/ORDER_RETURN`);
export const ORDER_STALE = `${NAME}/ORDER_STALE`;

// Invoice Status

export const INVOICE_STATUS = {
  PENDING: {
    label: 'Pending',
    color: 'neutral',
    tag: 'neutral',
    key: 'pending',
    searchKey: 'status',
    searchValue: 'pending',
    hex: NEUTRAL,
  },
  RECEIVED: {
    label: 'Received',
    color: 'success',
    tag: 'success',
    key: 'received',
    searchKey: 'status',
    searchValue: 'received',
    hex: SUCCESS,
  },
  NOT_RECEIVED: {
    label: 'Not Received',
    color: 'danger',
    tag: 'danger',
    key: 'not_received',
    searchKey: 'status',
    searchValue: 'not_received',
    hex: DANGER,
  },
  PARTIALLY_RECEIVED: {
    label: 'Partially Received',
    color: 'warning',
    tag: 'warning',
    key: 'partially_received',
    searchKey: 'status',
    searchValue: 'partially_received',
    hex: WARNING,
  },
  NOT_MATCHED: {
    label: 'Mismatched',
    key: 'not_matched',
    format: 'count',
    searchKey: 'matched',
    searchValue: '-1',
  },
  MATCHED: {
    label: 'Matched',
    key: 'matched',
    format: 'count',
    searchKey: 'matched',
    searchValue: '1',
  },
  VOID: {
    label: 'Void',
    color: 'neutral',
    tag: 'neutral',
    key: 'status',
    hex: NEUTRAL,
  },
  TOTAL: {
    label: 'Total',
    color: 'primary',
    tag: 'primary',
    key: 'total',
    hex: PRIMARY,
  },
  HAS_ALL_GLCODES_SET: {
    label: 'GL Coded',
    key: 'glcoded',
    searchKey: 'glcode',
    searchValue: '1',
  },
  NOT_ALL_GLCODES_SET: {
    label: 'Not GL Coded',
    key: 'not_glcoded',
    searchKey: 'glcode',
    searchValue: '0',
  },
};

export const InvoiceStatementParseStatus = {
  PENDING: 'PENDING',
  REVIEWED: 'REVIEWED',
};

export const INVOICE_STATUS_KIND = _.mapValues(INVOICE_STATUS, (s, key) => key);

export const INVOICE_AGGREGATE_KEYS = [
  INVOICE_STATUS_KIND.PENDING,
  INVOICE_STATUS_KIND.RECEIVED,
  INVOICE_STATUS_KIND.PARTIALLY_RECEIVED,
  INVOICE_STATUS_KIND.NOT_RECEIVED,
  INVOICE_STATUS_KIND.TOTAL,
  INVOICE_STATUS_KIND.NOT_MATCHED,
  INVOICE_STATUS_KIND.HAS_ALL_GLCODES_SET,
  INVOICE_STATUS_KIND.NOT_ALL_GLCODES_SET,
];

export const INVOICE_AGGREGATE_KEYS_SHOW_ALL = [
  INVOICE_STATUS_KIND.PENDING,
  INVOICE_STATUS_KIND.RECEIVED,
  INVOICE_STATUS_KIND.PARTIALLY_RECEIVED,
  INVOICE_STATUS_KIND.NOT_RECEIVED,
  INVOICE_STATUS_KIND.TOTAL,
  INVOICE_STATUS_KIND.NOT_MATCHED,
];

export const INVOICE_AGGREGATE_KEYS_GLCODE = [
  INVOICE_STATUS_KIND.HAS_ALL_GLCODES_SET,
  INVOICE_STATUS_KIND.NOT_ALL_GLCODES_SET,
];

export const INVOICE_MISMATCH_TYPE = {
  PRICE_CHANGE: 'PRICE_CHANGE',
  QTY_CHANGE: 'QTY_CHANGE',
  NEW_ITEM: 'NEW_ITEM',
  REMOVED_ITEM: 'REMOVED_ITEM',
  ACCOUNT_CHANGE: 'ACCOUNT_CHANGE',
  CUSTOM: 'CUSTOM',
  MISSING_SPEND_CATEGORY: 'MISSING_SPEND_CATEGORY',
  MISSING_VETCOVE_PO: 'MISSING_VETCOVE_PO'
};

export const ORDER_STATUS = {
  COMPLETED: {
    value: 'completed',
    name: 'Completed'
  },
  OPEN: {
    value: 'open',
    name: 'Processed'
  },
  CANCELLED: {
    value: 'cancelled',
    name: 'Cancelled'
  },
  RETURN: {
    value: 'return',
    name: 'Return',
  },
  MISC: {
    value: 'misc',
    name: 'Misc'
  },
  FAILED_PAYMENT: {
    value: 'failed_payment',
    name: 'Failed Payment'
  },
  UNKNOWN: {
    value: 'unknown',
    name: 'Unknown'
  },
  DELETED: {
    value: 'deleted',
    name: 'Deleted'
  },
  DROP_SHIP: {
    value: 'drop_ship',
    name: 'Drop Ship'
  },
  VETCOVE_TRANSIENT: {
    value: 'vetcove_transient',
    name: 'Vetcove Transient'
  },
  BACKORDERED: {
    value: 'backordered',
    name: 'Backordered'
  },
  PENDING: {
    value: 'pending',
    name: 'Pending'
  },
  SHIPPED: {
    value: 'shipped',
    name: 'Shipped'
  }
};

export const matchesPathwayThriveWorkdayPOStructure = (poNumber) => {
  const re = new RegExp('^PO\\s*-?\\s*\\d{7}$');
  return re.test(poNumber);
};

export const pathwayThriveWorkdayPOStructureErrorMessage = (
  `Please complete the task 'Create Receipt' in Workday for this Purchase Order. You can find the ‘Create Receipt’ job 
  aid along with other Workday Procurement Job Aids by selecting the Workday Job Aids worklet on the Workday home page.
    For questions, please email supplychainhelp@pathwayvets.com.`
);
